const ComplianceConcernsModal = ({ onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
      zIndex: 1000
    }}>
      <h2 style={{ fontSize: '22px' }}>Compliance Concerns</h2>
      <div style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '20px', marginBottom: '10px' }}>
        Primary Appeals Contact
      </div>
      <div>
        <strong>Name:</strong> Reveka Pinkhasova
      </div>
      <div>
        <strong>Title:</strong> Program Director, Clinical Services
      </div>
      <div>
        <strong>Email:</strong>{' '}
        <a href="mailto:rpinkhasova@win-healthcare.com" style={{ color: '#ec008c', textDecoration: 'underline' }}>
          rpinkhasova@win-healthcare.com
        </a>
      </div>
      <div>
        <strong>Mailing Address:</strong><br />
        1 American Lane<br />
        Greenwich, CT 06831
      </div>
      <div>
<a
  href="/documents/TN Addendum To WINRx PBM Manual V5 (1).docx"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: '#ec008c',
    textDecoration: 'underline',
    fontWeight: 'bold'
  }}
>
  View TN Addendum To WINRx PBM Manual
</a>
      
    </div>
    <div>
        <h3>Appeals Process for TN Members only</h3>
<p>
While WIN does not currently implement audits or appeals, WIN commits to comply by maintaining an audits & appeals process under which a pharmacist or pharmacy may appeal an unfavorable preliminary audit report in the case that we do begin implementing audits.

Please see attached file for any further information on what that appeals process might look like in accordance with TN laws and regulations, in the event that WIN does begin to implement audits.
</p>
    </div>
    <div>
        <button onClick={onClose} style={{ marginTop: '20px', padding: '10px 20px', background: '#ec008c', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>Close</button>
    </div>
    </div>
  );
};

export default ComplianceConcernsModal;
